import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit'
import { getData, patchData, getRemoteUrl, deleteData } from './request'
import { addCases } from './utils'
import { getLoginToken } from './store'


function setActivitiesData(state, { payload }) {
    state.activities = payload.activities

    if (!state.selectedActivity && state.selectedActivity !== payload.firstActivity) {
        state.selectedActivity = payload.firstActivity
        state.selectedActivityTrace = payload.activityTrace
    }

    state.activitiesLoading = false
}

function setActivitiesError(state, { error }) {
    state.activities = []
    state.activitiesLoading = false
    state.selectedActivity = undefined
    state.setSelectedActivityTrace = undefined
    state.requestError = error
}

function setActivitiesLoading(state) {
    state.activitiesLoading = true
}

function setSelectedActivityTrace(state, { payload }) {
    state.selectedActivityTrace = payload
}

function reqActivities() {
    const loginToken = getLoginToken()
    let params = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${loginToken}`
        }
    }
    const urlWithArgs = getRemoteUrl("activities?") + new URLSearchParams({'count': 1200, 'orderby':'start_time desc'})
    return getData(urlWithArgs, params)
        .then(activities => {
            if (activities.length > 0) {
                const firstActivity = activities[0]
                return reqActivityTrace(firstActivity.id).then(activityTrace => {
                    return {
                        activities: activities,
                        firstActivity: firstActivity,
                        activityTrace: activityTrace}
                })
            }
            return {activities: activities}
        })
}

function reqActivityTrace(activityId) {
    const loginToken = getLoginToken()
    let params = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${loginToken}`
        }
    }
    return getData(getRemoteUrl("activities/" + activityId + "/trace"), params)
        .then(json => json.trace)
}

export function reqChangeActivityName(activityId, newName) {
    let params = {
        name: newName
    }

    return patchData(getRemoteUrl("activities/" + activityId), params, getLoginToken())
}

export function reqDeleteActivity(activityId) {
    return deleteData(getRemoteUrl("activities/" + activityId), null, getLoginToken())
}


export const asyncReqActivities = createAsyncThunk('asyncReqActivities', reqActivities)
export const asyncReqActivityTrace = createAsyncThunk('asyncReqActivityTrace', reqActivityTrace)

export const activitiesSlice = createSlice({
    name: 'activities',
    initialState: {
        activities: undefined,
        activitiesLoading: false,
        selectedActivity: undefined,
        selectedActivityTrace: undefined
    },

    reducers: {
        setActivities(state, value) {
            setActivitiesData(state, value)
        },
        setActivityName(state, {payload}) {
            const oldState = current(state)
            let newState = {
                ...oldState,
                activities: oldState.activities.map(activity => {
                    if (activity.id !== payload.id) {
                        return activity
                    }
        
                    return {
                        ...activity,
                        name:payload.name
                    }
              })
            }
            return newState
        },
        setSelectedActivity(state, {payload}) {
            const oldState = current(state)
            let newState = {
                ...oldState,
                selectedActivity: payload,
                selectedActivityTrace: []
            }
            return newState
        },
        setSelectedActivityTrace(state, {payload}) {
            const oldState = current(state)
            let newState = {
                ...oldState,
                selectedActivityTrace: payload
            }
            return newState
        }
    },

    extraReducers: builder => {
        addCases(builder, asyncReqActivities, setActivitiesData, setActivitiesLoading, setActivitiesError)
        addCases(builder, asyncReqActivityTrace, setSelectedActivityTrace, undefined, setActivitiesError)
    }
})

export const { setActivities, setActivityName, setSelectedActivity } = activitiesSlice.actions
